import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=3b862aa4&scoped=true"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Review.vue?vue&type=style&index=0&id=3b862aa4&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./Review.vue?vue&type=style&index=1&id=3b862aa4&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3b862aa4",
  "339b480a"
  
)

export default component.exports